import { z } from 'zod';

/** Jenis aksi di log aktivitas admin. */
export const ACTIVITY_ACTIONS = ['CREATE', 'UPDATE', 'DELETE', 'EXPORT', 'OTHER'] as const;
export type ActivityAction = (typeof ACTIVITY_ACTIONS)[number];

/**
 * Kelompok menu di log. Menu biasa memakai kunci ADMIN_MODULES; dua yang
 * hanya milik super admin punya kunci sendiri.
 */
export const ACTIVITY_EXTRA_MODULES = {
  adminUsers: 'Admin User',
  access: 'Hak akses',
} as const;

const dateOnly = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);

export const activityQuerySchema = z.object({
  actorId: z.string().min(1).max(64).optional(),
  module: z.string().min(1).max(40).optional(),
  action: z.enum(ACTIVITY_ACTIONS).optional(),
  entityType: z.string().min(1).max(40).optional(),
  entityId: z.string().min(1).max(120).optional(),
  /** Cocokkan sebagian label, jalur, atau id objek. */
  q: z.string().trim().max(120).optional(),
  /** Tanggal WIB inklusif. */
  from: dateOnly.optional(),
  to: dateOnly.optional(),
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(100).default(50),
});

export const activityParamsSchema = z.object({ id: z.string().min(1).max(64) });

export type ActivityQuery = z.infer<typeof activityQuerySchema>;
